import Email from './index'
export default [
  {
    path: '/change/email',
    name: 'leyousafe-change-email',
    component: Email
  },
]
